import {Injectable} from '@angular/core';
import {RestService} from "./rest.service";

@Injectable({
  providedIn: 'root'
})
export class PermissionService extends RestService {
  endpoint(): string {
    return "permissions";
  }
  param1(): string {
    return "";
  }

  param2(): string {
    return "";
  }

  param3(): string {
    return "";
  }
}
